/**
 * ABD 20/10/2026: search suggestions and the search page's Collections row on the OLD theme, without Boost.
 * Same data and rules as the new site (assets/predictive-search.js, assets/abd-search-page.js, 14-15/10/2026):
 *  - products and menu collections come from sections/abd-drawer-results.liquid drawn on the full search page
 *    with the new site's exact-match query;
 *  - further matching collections come from Shopify's quick search (/search/suggest), drawn by
 *    sections/abd-search-collections.liquid, which leaves out the same collections as the new site;
 *  - collections are merged exactly as on the new site (menu ones first, no repeats, names must contain the words, max 8).
 * Shown as a dropdown under every search box (header search, phone menu search, search page box), never taller than
 * the screen (the list scrolls inside; the "View all results" bar stays visible), and as a "Collections" row on the
 * search results page. Enter still opens the full results page.
 */
(function () {
  if (window.abdSearchSuggestReady) return;
  window.abdSearchSuggestReady = true;

  // ---- Shared search data (identical logic to the new site's window.abdSearchData) ----
  function norm(s) {
    return (' ' + String(s || '').toLowerCase().replace(/[-&™,./()_:!+]/g, ' ').replace(/'/g, '') + ' ').replace(/\s+/g, ' ');
  }
  function needles(q) {
    return norm(q).trim().split(' ').filter(Boolean).map(function (w) {
      return w.length > 3 && w.slice(-1) === 's' ? w.slice(0, -1) : w;
    });
  }
  function matches(title, q) {
    var hay = norm(title);
    return needles(q).every(function (n) { return hay.indexOf(' ' + n) !== -1; });
  }
  function buildQuery(text) {
    var words = String(text || '').toLowerCase().replace(/[^a-z0-9À-ɏ ]+/g, ' ').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return '';
    return words.map(function (w) {
      var stem = w.length > 3 && w.slice(-1) === 's' ? w.slice(0, -1) : w;
      var parts = ['title:' + w + '*'];
      if (stem !== w) parts.push('title:' + stem + '*');
      ['product_type', 'tag', 'vendor', 'variants.title'].forEach(function (f) { parts.push(f + ':' + stem + '*'); });
      return '(' + parts.join(' OR ') + ')';
    }).join(' AND ');
  }
  function pageUrl(text) { return '/search?q=' + encodeURIComponent(buildQuery(text)); }
  function fetchText(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }
  var cache = {};
  function fetchAll(q, signal) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var a = new URLSearchParams({ q: buildQuery(q), type: 'product,article', section_id: 'abd-drawer-results' });
    var b = new URLSearchParams({ q: q, 'resources[type]': 'collection', 'resources[limit]': '10', 'resources[limit_scope]': 'each', section_id: 'abd-search-collections' });
    return Promise.all([
      fetchText('/search?' + a.toString(), signal),
      // One quiet retry if Shopify's quick search is busy, so a matching collection isn't missed.
      fetchText('/search/suggest?' + b.toString(), signal).catch(function (e) {
        if (e.name === 'AbortError') throw e;
        return new Promise(function (res) { setTimeout(res, 700); }).then(function () {
          return fetchText('/search/suggest?' + b.toString(), signal);
        }).catch(function (e2) { if (e2.name === 'AbortError') throw e2; return null; });
      })
    ]).then(function (res) {
      var partial = res[1] === null;
      var doc = new DOMParser().parseFromString(res[0], 'text/html');
      var root = doc.querySelector('.abd-drawer-results');
      if (!root) throw new Error('no results markup');
      var max = parseInt(root.dataset.maxCollections, 10) || 8;
      var list = [];
      var seen = {};
      var seenTitle = {};
      root.querySelectorAll('[data-abd-collection]').forEach(function (row) {
        var link = row.querySelector('a');
        var img = row.querySelector('img');
        var tkey = norm(link.textContent);
        seen[row.dataset.abdCollection] = true;
        if (seenTitle[tkey]) return;
        seenTitle[tkey] = true;
        list.push({ handle: row.dataset.abdCollection, url: link.getAttribute('href'), title: link.textContent.trim(), img: img ? img.getAttribute('src') : '' });
      });
      var extra = new DOMParser().parseFromString(res[1] || '', 'text/html');
      extra.querySelectorAll('.abd-search-collections__item').forEach(function (item) {
        if (list.length >= max) return;
        var url = item.getAttribute('href') || '';
        var handle = (url.split('/collections/')[1] || '').split(/[?#/]/)[0];
        var title = (item.querySelector('.abd-search-collections__title') || item).textContent.trim();
        if (!handle || seen[handle] || seenTitle[norm(title)] || !matches(title, q)) return;
        seen[handle] = true;
        seenTitle[norm(title)] = true;
        var img = item.querySelector('img');
        list.push({ handle: handle, url: url.split('?')[0], title: title, img: img ? img.getAttribute('src') : '' });
      });
      var products = Array.prototype.slice.call(root.querySelectorAll('.abd-search-panel--products > .abd-sg__row'), 0, 8).map(function (r) { return r.outerHTML; });
      var data = { q: q, partial: partial, collections: list, products: products, total: parseInt(root.dataset.totalProducts, 10) || parseInt(root.dataset.products, 10) || 0 };
      if (!partial) cache[q] = data;
      return data;
    });
  }
  window.abdSearchData = window.abdSearchData || { fetch: fetchAll, query: buildQuery, pageUrl: pageUrl, matches: matches };

  // ---- Styles (old site's fonts and colours) ----
  var css = '' +
    '.abd-sg{position:fixed;z-index:2147483000;background:#fff;border:1px solid #e5e5e5;box-shadow:0 8px 24px rgba(0,0,0,.12);font-family:Inter,sans-serif;text-align:left;display:flex;flex-direction:column}' +
    '.abd-sg[hidden]{display:none}' +
    /* The list scrolls inside the box; the "View all results" bar stays at the bottom, always on screen. */
    '.abd-sg__scroll{overflow-y:auto;-webkit-overflow-scrolling:touch;flex:0 1 auto;min-height:0;overscroll-behavior:contain}' +
    /* Phones: tighter rows so more results fit above the keyboard, and the search panel's box sits near the top. */
    '@media (max-width:767px){.abd-sg__head{padding:8px 12px 4px !important}.abd-sg a{padding-top:6px !important;padding-bottom:6px !important}.abd-sg img{width:36px !important;height:36px !important}.abd-sg__foot{padding:8px !important}.abd-sg__all{padding:10px !important}#search form{padding-top:0 !important;margin-top:0 !important}#search .search-close{position:fixed !important;top:10px;right:14px;z-index:2147483001;margin:0 !important;padding:0 !important;float:none !important;width:auto !important;height:auto !important}#search .container{padding-top:56px !important}}' +
    '.abd-sg__head{padding:14px 16px 6px;font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#000}' +
    '.abd-sg__item{display:flex;align-items:center;gap:12px;padding:8px 16px;color:#3d4246;text-decoration:none}' +
    '.abd-sg__item:hover,.abd-sg__item:focus{background:#fef6f9}' +
    '.abd-sg__img{flex:0 0 48px;width:48px;height:48px;background:#f5f5f5;overflow:hidden;display:block}' +
    '.abd-sg__img img{width:48px;height:48px;object-fit:cover;display:block}' +
    '.abd-sg__text{display:flex;flex-direction:column;min-width:0}' +
    '.abd-sg__title{font-size:14px;line-height:1.35;font-weight:600;color:#3d4246}' +
    '.abd-sg__price{font-size:13px;line-height:1.4;color:#222}' +
    '.abd-sg__price s{color:rgba(34,34,34,.6);margin-left:4px}.abd-sg__sale{color:#ff3300}' +
    '.abd-sg__foot{flex:0 0 auto;padding:8px 16px 14px;background:#fff;border-top:1px solid #f0f0f0}' +
    '.abd-sg__all{display:block;padding:11px 12px;background:#222;color:#fff !important;text-align:center;font-size:13px;letter-spacing:.5px;text-decoration:none}' +
    '.abd-sg__all:hover{background:#ef6693}' +
    '.abd-sg__empty{padding:16px;font-size:14px;color:#3d4246}' +
    '.abd-pfs-collections{margin:4px auto 0;padding:0 15px 20px;max-width:1270px;text-align:left}' +
    '.abd-pfs-collections[hidden]{display:none}' +
    '.abd-pfs-collections__label{margin:0 0 12px;font-family:Inter,sans-serif;font-size:14px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#000}' +
    '.abd-pfs-collections__list{display:flex;gap:12px;overflow-x:auto;scrollbar-width:none;padding-bottom:2px}' +
    '.abd-pfs-collections__list::-webkit-scrollbar{display:none}' +
    '.abd-pfs-collections__item{display:flex;align-items:center;gap:12px;flex:0 0 auto;max-width:300px;padding:8px 16px 8px 8px;border:1px solid #e5e5e5;color:#3d4246;text-decoration:none;font-family:Inter,sans-serif;font-size:14px;font-weight:600;line-height:1.3;background:#fff}' +
    '.abd-pfs-collections__item:hover{border-color:#222}' +
    '.abd-pfs-collections__item img,.abd-pfs-collections__ph{width:56px;height:56px;object-fit:cover;flex:0 0 56px;background:#f4f4f4;display:block}' +
    '@media (max-width:767px){.abd-pfs-collections__item{max-width:240px;font-size:13px}.abd-pfs-collections__item img,.abd-pfs-collections__ph{width:48px;height:48px;flex-basis:48px}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  // The typed words in bold, as Boost did.
  function collectionLink(c, cls) {
    var img = c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy">' : '';
    if (cls === 'row') return '<a class="abd-pfs-collections__item" href="' + esc(c.url) + '">' + (img || '<span class="abd-pfs-collections__ph"></span>') + '<span>' + esc(c.title) + '</span></a>';
    return '<a class="abd-sg__item" href="' + esc(c.url) + '"><span class="abd-sg__img">' + img + '</span><span class="abd-sg__text"><span class="abd-sg__title">' + esc(c.title) + '</span></span></a>';
  }


  // ---- Collections row on the search results page ----
  function fillRow() {
    var row = document.querySelector('.abd-pfs-collections');
    if (!row) return;
    var q = (row.getAttribute('data-q') || '').trim();
    if (!q) return;
    fetchAll(q).then(function (data) {
      var list = row.querySelector('.abd-pfs-collections__list');
      list.innerHTML = data.collections.map(function (c) { return collectionLink(c, 'row'); }).join('');
      row.hidden = data.collections.length === 0;
    }).catch(function () {});
  }

  // ---- Dropdown under the search boxes ----
  var panel = document.createElement('div');
  panel.className = 'abd-sg';
  panel.hidden = true;
  panel.setAttribute('role', 'listbox');
  var activeInput = null;
  var timer = null;
  var controller = null;

  function place() {
    if (!activeInput || panel.hidden) return;
    var r = activeInput.getBoundingClientRect();
    if (!r.width) { close(); return; }
    var w = Math.max(r.width, Math.min(420, window.innerWidth - 16));
    w = Math.min(w, window.innerWidth - 16);
    var left = Math.min(Math.max(8, r.left), window.innerWidth - w - 8);
    var top = r.bottom + 4;
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
    panel.style.width = w + 'px';
    // Never taller than the visible screen: the list scrolls inside, the "View all results" bar stays in view.
    // On phones the keyboard shrinks the visible area and the browser scrolls it (offsetTop), so measure the
    // bottom of what can actually be seen, not the full screen.
    var vv = window.visualViewport;
    var visibleBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    panel.style.maxHeight = Math.max(120, visibleBottom - top - 8) + 'px';
  }
  function close() { panel.hidden = true; }
  function render(q, data) {
    var html = '<div class="abd-sg__scroll">';
    if (data.collections.length) {
      html += '<div class="abd-sg__head">Collections</div>' + data.collections.map(function (c) { return collectionLink(c); }).join('');
    }
    if (data.products.length) {
      html += '<div class="abd-sg__head">Products</div>' + data.products.join('');
    }
    if (!data.collections.length && !data.products.length) html += '<div class="abd-sg__empty">No results for &ldquo;' + esc(q) + '&rdquo;</div>';
    html += '</div>';
    if (data.collections.length || data.products.length) {
      html += '<div class="abd-sg__foot"><a class="abd-sg__all" href="' + esc(pageUrl(q)) + '">View all results for &ldquo;' + esc(q) + '&rdquo;</a></div>';
    }
    panel.innerHTML = html;
    panel.hidden = false;
    place();
  }
  function run(input) {
    var q = input.value.trim();
    if (controller) controller.abort();
    if (q.length < 2) { close(); return; }
    activeInput = input;
    controller = new AbortController();
    fetchAll(q, controller.signal).then(function (data) {
      if (input.value.trim() === q && activeInput === input) render(q, data);
    }).catch(function (e) { if (e.name !== 'AbortError') close(); });
  }
  function isSearchInput(el) {
    if (!el || el.tagName !== 'INPUT' || el.getAttribute('name') !== 'q') return false;
    var f = el.form;
    return !!f && (f.getAttribute('action') || '').split('?')[0] === '/search';
  }

  document.addEventListener('input', function (e) {
    if (!isSearchInput(e.target)) return;
    clearTimeout(timer);
    var input = e.target;
    timer = setTimeout(function () { run(input); }, 300);
  }, true);
  document.addEventListener('focusin', function (e) {
    if (isSearchInput(e.target) && e.target.value.trim().length >= 2 && cache[e.target.value.trim()]) {
      activeInput = e.target;
      render(e.target.value.trim(), cache[e.target.value.trim()]);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('submit', function () { close(); }, true);
  document.addEventListener('mousedown', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target) || e.target === activeInput) return;
    close();
  });
  document.addEventListener('touchstart', function (e) {
    if (panel.hidden) return;
    if (panel.contains(e.target) || e.target === activeInput) return;
    close();
  }, { passive: true });
  window.addEventListener('resize', place);
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', place); window.visualViewport.addEventListener('scroll', place); }
  window.addEventListener('scroll', place, true);

  function start() {
    document.body.appendChild(panel);
    fillRow();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
